app.service('deliveryView', function (console, deliveryPoints, orderConfig, regon, companyName, agreementsSubmit,
	orderUtils, modal, broker, deliveryInputs, deliveryLocation, validate, emailInvalid, front, cartRetrieve,
	permissions, selectModal, unavailableItemsModal) {
	var $self, $form, $phone, $receiverPhone, $deliverySelect, $receiverSelect, $invoiceSelect,
		$operatorClientEmail, $operatorClientEmailRow, $next, $countryCode, $invoiceCountryCode;
	var config;
	var initConfig;
	let isOneInit = false;

	function setCompanyDeliveryType() {
		console.log('ZAKUPY JAKO FIRMA');
		config.deliveryInfo.frontUserType = 'COMPANY';
		$self.addClass('user-type-company').removeClass('user-type-individual');
		checkIgnoreInput();
	}
	function setIndividualDeliveryType() {
		console.log('ZAKUPY JAKO OSOBA PRYWATNA');
		config.deliveryInfo.frontUserType = 'INDIVIDUAL';
		$self.removeClass('user-type-company').addClass('user-type-individual');
		checkIgnoreInput();
	}
	function switchDeliveryAddress(value) {
		if (value === 'true') {
			console.log('ADRES DOSTAWY TAKI SAM');
			config.deliveryInfo.deliveryEqualsHome = true;

		} else {
			console.log('ADRES DOSTAWY INNY');
			config.deliveryInfo.deliveryEqualsHome = false;
		}
		checkIgnoreInput();
	}
	function switchReceiverData(value) {

		if (value === "false") {
			console.log('DANE ODBIORCY - takie same');
			config.deliveryInfo.sameReceiver = true;

		} else {
			console.log('DANE ODBIORCY - inne');
			config.deliveryInfo.sameReceiver = false;
		}
		checkIgnoreInput();
	}

	function changeTextNextButton(value){
		$next.text(value ? config.taxFreeNextButtonText : config.nextButtonText);
	}
	function switchTaxFree(value) { 
		if (value === 'true' && config.deliveryInfo.taxfree === false) {
			console.log('CHCĘ TAXFREE');
			config.deliveryInfo.taxfree = true;
			config.deliveryInfo.invoiceNeeded = false;
			changeTextNextButton(true);
		} else if (value === 'false' && config.deliveryInfo.taxfree === true){
			console.log('NIE CHCĘ TAXFREE');
			config.deliveryInfo.taxfree = false;
			changeTextNextButton(false);
		}
		$('#preview-order-steps .row-delivery-point').hide();
		$('#container').removeClass('hide-shops');
		deliveryLocation.refresh({scroll:false});
		checkIgnoreInput();
	}
	function switchProductWithCouponAvailable(value) {
		if (value === 'true' && config.deliveryInfo.productWithCoupon === false) {
			config.deliveryInfo.productWithCoupon = true;
			config.deliveryInfo.invoiceNeeded = false;
			console.log('CHCĘ BON');
			changeTextNextButton(true);
		} else if (value === 'false' && config.deliveryInfo.productWithCoupon === true) {
			config.deliveryInfo.productWithCoupon = false;
			console.log('NIE CHCĘ BONU');
			changeTextNextButton(false);
		}
		checkIgnoreInput();
	}
	function switchInvoiceAddress(value) {
		if (value === 'true') {
			console.log('INNY ADRES FAKTURY');
			config.deliveryInfo.invoiceNeeded = true;
		} else {
			console.log('TAKI SAM ADRES DO FAKTURY');
			config.deliveryInfo.invoiceNeeded = false;
		}
		checkIgnoreInput();
	}
	function checkIgnoreInput() {
		var option = config.deliveryInfo;
		option.deliveryType = config.deliveryType;
		deliveryInputs.prevalidate(option);
	}
	function copyPassword(password) {
		$('#password2').val(password);
	}
	function copyDeliveryAddress(i) {
		console.log('KOPIOWANIE DANYCH DO DOSTAWY');
		var address = config.deliveryAddresses[i];
		deliveryInputs.deliveryAddressSwitch(address);
		if (i != "0") {
			$('#delivery-address input').checkValid();
		}
	}
	function copyReceiverData(id) {
		console.log('KOPIOWANIE DANYCH ODBIORCY');
		var receiverData;

		if (id === "0") {
			receiverData = config.receiverDatas[0];
		} else {
			receiverData = config.receiverDatas.find(function(data) {
				return data.id === id;
			});
		}

		if (receiverData) {
			deliveryInputs.receiverDataSwitch(receiverData);
			if (id !== "0") {
				$('#receiver-data input').checkValid();
			}
		} else {
			console.log('Nie znaleziono danych odbiorcy o podanym id: ' + id);
		}
	}
	function copyInvoiceData(id) {
		console.log('KOPIOWANIE DANYCH DO FAKTURY');
		var address;
		if (id === "0") {
			address = config.invoiceAddresses[0];
		} else {
			address = config.invoiceAddresses.find(function(data) {
				return data.id === id;
			});
		}
		if (address) {
			deliveryInputs.invoiceAddressSwitch(address);
			setInvoiceZipCode(address.countryCode || "PL");
			if (id !== "0") {
				$('input[name^=invoice]').checkValid();
			}
		} else {
			console.log('Nie znaleziono danych do faktury o podanym id: ' + id);
		}
	}
	function next() {
		console.log('DALEJ NA 3 KROKU');
		if (unavailableItemsModal.checkStatus()) {
			return;
		}
		deliveryInputs.validate(config);
	}
	function back() {
		orderUtils.back();
	}
	function showEuTaxInfo() {
		modal.open('eu-tax-info', { modifier: 'remodal-full-width' });
	}
	function setElements() {
		config = orderConfig.getData();
		initConfig = JSON.parse(JSON.stringify(orderConfig.getData()));
		switch (config.deliveryType) {
			case 'home':
				$self = $('#home-delivery #container');
				break;
			case 'shop':
				$self = $('#shop-delivery #container');
				break;
			case 'inpost':
			case 'pickupPoints':
			case 'mail':
			case 'phone':
				$self = $('#home-delivery #container');
				break;
		}
		if (!($self && $self.length)) {
			console.log('błąd generowania strony', config)
		}
		$form = $('#choose-delivery-form', $self);
		$phone = $('#phone', $self);
		$countryCode = $self.find('#country-code');
		$receiverPhone = $('#receiver-phone', $self);
		$deliverySelect = $('#delivery-select', $self);
		$receiverSelect = $('#receiver-select', $self);
		$invoiceSelect = $('#invoice-select', $self);
		$invoiceCountryCode = $self.find('#invoice-country-code');
		$paperInvoiceStatus = $('#paper-invoice-status', $self);
		$paperInvoiceMessage = $('#address-delivery-paper-invoice-message', $self);
		$operatorClientEmail = $('#e-mail', $self);
		$operatorClientEmailRow = $('#e-mail-row', $self);
		$next = $('.js-delivery-next', $self);
	}
	function toggleEmail(checked) {
		$operatorClientEmail.ignore(checked);
		$operatorClientEmail.prop('disabled', checked);
		config.operatorClientNoMail = checked;
		if (checked) {
			$self.addClass('operator-no-email');
			$operatorClientEmailRow.addClass('row-input-disabled');
		} else {
			$self.removeClass('operator-no-email');
			$operatorClientEmailRow.removeClass('row-input-disabled');
		}
	}

	function setEvents() {
		$self.on('click', '.js-delivery-next', function () {
			next();
		}).on('click', '.js-delivery-back', function () {
			back();
		});
		$('#no-email', $self).click(function () {
			toggleEmail($(this).is(':checked'));
		});
		emailInvalid.init($operatorClientEmail, $('#email-invalid-text'), $operatorClientEmailRow);
		$('#company', $self).on('click', function () {
			setCompanyDeliveryType();
		});
		$('#individual', $self).on('click', function () {
			setIndividualDeliveryType();
		});
		$('#password', $self).on('focusout', function () {
			copyPassword($(this).val());
		});

		$('input[type=radio].js-delivery-home', $self).on('click', function () {
			switchDeliveryAddress($(this).val());
		});
		//przełączanie danych odbiorcy innych niż użytkownika
		$('input[type=radio].js-switch-receiver-data', $self).on('click', function () {
			switchReceiverData($(this).val());
		});
		//przełączanie danych do faktury innego niż użytkownika
		$('input[type=radio].js-invoice-needed', $self).on('click', function () {
			switchInvoiceAddress($(this).val());
		});
		$('input[type=radio].js-taxfree-needed', $self).on('click', function () {
			switchTaxFree($(this).val());
		});
		$('input[type=radio].js-reservation-needed', $self).on('click', function () {
			switchReservation($(this).val());
		});
		$('input[type=radio].js-product-with-coupon', $self).on('click', function () {
			switchProductWithCouponAvailable($(this).val());
		});
		//informacja o wybraniu formy dokumentów zakupowych
		$paperInvoiceStatus.on('change', function () {
			$(this).val() == 'true' ? $paperInvoiceMessage.addClass('show') : $paperInvoiceMessage.removeClass('show');
		});
		//wybór danych w selekcie adresów dostawy
		$deliverySelect.on('change', function () {
			copyDeliveryAddress($(this).val());
		});
		//wybór danych w selekcie danych odbiorcy
		$receiverSelect.on('change', function () {
			copyReceiverData($(this).val());
			setPolishPhonePrefixForReceiver();
		});
		//wybór danych w selekcie danych do faktury
		$invoiceSelect.on('change', function () {
			copyInvoiceData($(this).val());
		});

		//Jesli uzytkownik jest zalogowany i zmieni dane przy wyborze sklepu, pokaz komunikat(zgode) o przetwarzaniu danych
		$self.on('change', 'input:not([type="checkbox"])', function () {
			$self.removeClass('hide-permissions-desc');
		})

		$countryCode.on('change', function handleCountryCodeChange() {
			$form.validate().element($(this));
			if ($('#zip-code').val().length) {
				$form.validate().element($('#zip-code'));
			}

			const countryCode = $(this).val();
			if (countryCode === 'PL') {
				if (emptyDeliveryData()) {
					$('input[type=radio].js-delivery-home').val([true]);
					switchDeliveryAddress('true');
				}
				$.cityAutocomplete('#zip-code', '#city-name', config.streetValidateEnable ? '#home-address-street' : false);
				
				$self.removeClass('hide-home-delivery-controls');
			} else {
				$('input[type=radio].js-delivery-home').val([false]);
				switchDeliveryAddress('false')
				$.cityUnautocomplete('#zip-code', '#city-name', '#home-address-street');
				$self.addClass('hide-home-delivery-controls');
			}
			setZipCode(countryCode);

			if(hasChangedPolishCountryCode($countryCode)) {
				$('#zip-code, #city-name, #home-address-street, #home-house-number ,#home-flat-number').val(''); // czyścimy dane adresowe
			}
			$(this).data('prev-value', $(this).val());
		});

		setZipCode($countryCode.val());

		$invoiceCountryCode.on('change', function handleInvoiceCountryCodeChange() {
			$form.validate().element($(this));
			if ($('#invoice-zip-code').val().length) {
				$form.validate().element($('#invoice-zip-code'));
			}

			const countryCode = $(this).val();
			if (countryCode  === 'PL') {
				$.cityAutocomplete('#invoice-zip-code', '#invoice-city-name', config.streetValidateEnable ? '#invoice-street' : false);
			} else {
				$.cityUnautocomplete('#invoice-zip-code', '#invoice-city-name', '#invoice-street');
			}
			setInvoiceZipCode(countryCode);

			if (hasChangedPolishCountryCode($invoiceCountryCode)) {
				$('#invoice-street, #invoice-house-number, #invoice-flat-number, #invoice-zip-code, #invoice-city-name').val(''); // czyścimy dane adresowe
			}
			$(this).data('prev-value', $(this).val());
		});

		setInvoiceZipCode($invoiceCountryCode.val());

		$('.js-eu-tax-info', $self).on('click', function () {
			showEuTaxInfo();
		});

		if ($countryCode.val() === 'PL') {
			$.cityAutocomplete('#zip-code', '#city-name', config.streetValidateEnable ? '#home-address-street' : false);
		}

		$.cityAutocomplete('#delivery-zip-code', '#delivery-city-name', config.streetValidateEnable ? '#delivery-street' : false);

		if ($invoiceCountryCode.val() === 'PL') {
			$.cityAutocomplete('#invoice-zip-code', '#invoice-city-name', config.streetValidateEnable ? '#invoice-street' : false);
		}

		companyName.init('company-name');					//przeniosłem tutaj ponieważ nazwa firmy musi mieć już zdarzenia zanim dane do faktury będą się kopiować
		companyName.init('invoice-company-name');

		if ($deliverySelect.length) {
			copyDeliveryAddress($deliverySelect.val());
		}

		$('#permissions-list.old-mode input').click(function () {
			$('#current-permissions-message').addClass('loading');
			setTimeout(function () {
				$('#current-permissions-message').remove();
				$('#permissions-list').removeClass('old-mode');
				$('#permissions-displayed').val('true');
			}, 1000);
		});

		$('#phone-country-code-selector').on('change', function() {
			$form.validate().element($(this));

			if (config.deliveryInfo.isCellPhoneRequired) {
				setForeignReceiverPhone($(this).val());
			}
			if (hasChangedPolishPhonePrefix($(this))) {
				if ($phone.val().length) {
					$phone.val('');
					$form.validate().element($phone);
				}
			}
			$(this).data('prev-value', $(this).val());
		});

		$('#receiver-phone-country-code-selector').on('change', function() {
			$form.validate().element($(this));

			if ($receiverPhone.val().length) {
				$form.validate().element($receiverPhone);
			}
			if (hasChangedPolishPhonePrefix($(this))) {
				if ($receiverPhone.val().length) {
					$receiverPhone.val('');
					$form.validate().element($receiverPhone);
				}
			}
			$(this).data('prev-value', $(this).val());
		});

		$phone.phoneFormat();
		$receiverPhone.phoneFormat();

		if ($('#no-email').length) {
			toggleEmail($('#no-email').is(':checked'));
		}

		validate.task('chooseDelivery', {
			deliveryType: config.deliveryType,
			emailRequired: config.emailRequired,
			isPolishAddressRequired: config.deliveryInfo.isPolishAddressRequired,
			isPolishReceiverPhoneNumberRequired: config.deliveryInfo.isPolishReceiverPhoneNumberRequired,
			isPolishCustomerPhoneNumberRequired: config.deliveryInfo.isPolishCustomerPhoneNumberRequired
		});
		checkIgnoreInput();
		if(!isOneInit){
			isOneInit = true;
			broker.on('ORDER-NEXT-STEP', function () {
				if(config.pageType == 'delivery'){
					next();
				}
			});
			broker.on('PREVIEW_REFRESH', function () {
				if(front.page() === 'shop-delivery' || front.page() === 'home-delivery'){
					$next = $('.js-delivery-next', $self);
					changeTextNextButton(config.deliveryInfo.taxfree || config.deliveryInfo.productWithCoupon);
				}
			});
		}
	}

	function emptyDeliveryData() {
		let $deliveryInputs = $('#delivery-zip-code, #delivery-city-name, #delivery-street, #delivery-house-number, #delivery-flat-number');

		return $deliveryInputs.filter(function () {
			return $(this).val() !== '';
		}).length === 0;
	}

	function hasChangedPolishPhonePrefix($prefix) {
		const previousValue = $prefix.data('prev-value');
		const currentValue = $prefix.val();

		if (previousValue === '+48' && currentValue !== '+48') {
			return true;
		}

		if (previousValue !== '+48' && currentValue === '+48') {
			return true;
		}

		return false;
	}

	function hasChangedPolishCountryCode($countryCode) {
		const previousValue = $countryCode.data('prev-value');
		const currentValue = $countryCode.val();

		if (previousValue === 'PL' && currentValue !== 'PL') {
			return true;
		}

		if (previousValue !== 'PL' && currentValue === 'PL') {
			return true;
		}

		return false;
	}

	function setZipCode(countryCode) {

		const isPolishCountryCode = countryCode === 'PL';
		const maxLength = isPolishCountryCode ? 6 : 8;
		const type = isPolishCountryCode ? 'tel' : 'text';

		$('#zip-code:not([type=hidden])').prop({
			'maxlength': maxLength,
			'type': type
		});
	}

	function setInvoiceZipCode(countryCode) {
		const isPolishCountryCode = countryCode === 'PL';
		const maxLength = isPolishCountryCode ? 6 : 8;
		const type = isPolishCountryCode ? 'tel' : 'text';

		$('#invoice-zip-code').prop({
			'maxlength': maxLength,
			'type': type
		});
	}

	function setForeignReceiverPhone(phonePrefix) {
		if (phonePrefix !== '+48') {
			switchReceiverData(true);
			$('input[type=radio].js-switch-receiver-data').val([true]);
			$self.addClass('hide-receiver-data-controls');
			setPolishPhonePrefixForReceiver();
		} else {
			switchReceiverData(false);
			$self.removeClass('hide-receiver-data-controls');
		}
	}

	function setPolishPhonePrefixForReceiver() {
		// TODO: tymczasowe rozwiązanie, konieczność rozbudowy select.js o metodę setValue()
		let $select = $('#receiver-phone-country-code-selector');
		let $input = $select.parent().find(".js-customic-select-input");
		let $message = $select.parent().find(".js-customic-select-message");
		let $options = $select.parent().find('.js-customic-select-option');
		$options.removeAttr('data-selected');
		let $selectedOption = $options.filter(function() {
			return $(this).data('value') === '+48';
		});
		$selectedOption.get(0).dataset.selected = true;
		$input.val('+48');
		$message.text('PL (+48)');
	}

	function initDeliveryLocation() {
		var selectLocationCallback = function (params) {
			$next.removeClass('btn-disabled');
			if (config.deliveryType == 'shop' && params && params.lastLocation && params.shopCode && params.cityCode) {
				config.shopCode = params.shopCode;
				config.cityCode = params.cityCode;
			}
			$('.js-k3-other-delivery-time', $self).on('click', function () {
				const checked = $(this).is(':checked');
				const text = checked ? 'Dalej' : config.nextButtonText;
				$next.text(text);
				$('.js-k3-other-delivery-time', $self).prop('checked', checked);
				$('#other-delivery-time-selection').val(checked);
			});
		};
		switch (config.deliveryType) {
			case 'shop':
				$next.addClass('btn-disabled');
				deliveryLocation.init({
					deliveryType: config.deliveryType
				},
					selectLocationCallback
				);
				break;
			case 'inpost':
			case 'pickupPoints':
				deliveryPoints.init(selectLocationCallback);
				setZipCodePoints();
				break;
		}
	}
	function init() {
		setElements();
		deliveryInputs.init($self);
		setEvents();
		permissions.init();
		initDeliveryLocation();
		selectModal.init();
		agreementsSubmit.init($form, $('#current-permissions input:checkbox'));
		unavailableItemsModal.init();
		regon.init({
			$box: $('.user-type-info .regon-box'),
			$nip: $('#nip'),
			$companyName: $('#company-name-textarea-div'),
			$city: $('#city-name'),
			$street: $('#home-address-street'),
			$houseNumber: $('#home-house-number'),
			$flatNumber: $('#home-flat-number'),
			$zipCode: $('#zip-code')
		});
		regon.init({
			$box: $('#invoice-data .regon-box'),
			$nip: $('#invoice-nip'),
			$companyName: $('#invoice-company-name-textarea-div'),
			$city: $('#invoice-city-name'),
			$street: $('#invoice-street'),
			$houseNumber: $('#invoice-house-number'),
			$flatNumber: $('#invoice-flat-number'),
			$zipCode: $('#invoice-zip-code')
		});
		if(testAB.getVar('ajax-order') !== 'B'){
			if(location.hash == '#edit-point'){
				$('.js-show-points').trigger('click');
			} else if(location.hash == '#edit-inpost'){
				$('.js-show-inpost').trigger('click');
			} else if(location.hash == '#edit-shop'){
				$('.js-show-shops').trigger('click');
			} else if(location.hash == '#edit-data'){
				$('.js-show-user-data').trigger('click');
			}
		}

	}
	function setZipCodePoints() {
		var $input = $('#zip-code');
		$input.on('blur', function () {
			let value = $input.val();
			if (/^\d{2}-\d{3}$/.test(value)) {
				deliveryPoints.setZipCode(value);
			}
		});
	}

	return {
		init
	};
});
